module.exports = __webpack_public_path__ + "img/slide-services-2.a29e6123.webp";